// src/hooks/useReferralBonus.js
import { useState, useCallback } from 'react';

/**
 * Referral rewards are handled entirely SERVER-SIDE now:
 *   - link_signup_referral() links the referred user at signup / OAuth callback
 *   - the referrer receives a discount at purchase time (see app/referrals/)
 *
 * The old client-side "apply referral code for a bonus" flow POSTed to
 * /auth/apply-referral-code, which does NOT exist on the backend — every call
 * 404'd and failed silently, so no bonus was ever granted and the modal never
 * showed. This hook is now a no-op that preserves the interface DashboardLayout
 * consumes, so the modal wiring stays intact without firing dead 404 requests.
 *
 * If a "referred user gets N credits" reward is ever desired, that's a product
 * decision: build a real /auth/apply-referral-code endpoint (grants credits) and
 * restore the apply/eligibility calls in services/authApi.js.
 *
 * @returns {Object} - { showBonusModal, closeBonusModal, bonusDetails }
 */
export const useReferralBonus = () => {
    const [showBonusModal, setShowBonusModal] = useState(false);
    const closeBonusModal = useCallback(() => setShowBonusModal(false), []);

    return {
        showBonusModal,
        closeBonusModal,
        bonusDetails: { creditsAdded: 0, tokensAdded: 0 },
    };
};

export default useReferralBonus;
